import React, { useState, useEffect } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { filter } from 'lodash';
import { useNavigate, NavLink } from 'react-router-dom';
import axios from 'axios';
import {
  Card,
  MenuItem,
  FormLabel,
  Stack,
  Row,
  Grid,
  Avatar,
  Box,
  Button,
  Popover,
  Checkbox,
  Modal,
  Typography,
  Container,
  TableContainer,
  TablePagination,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Scrollbar from '../components/scrollbar';
import Iconify from '../components/iconify';
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';

import Loader from './loader/Loader';

function createData(name, calories, fat, carbs, protein, detail) {
  return { name, calories, fat, carbs, protein, detail };
}

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

const ExpandableTableRow = ({ children, expandComponent, ...otherProps }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <>
      <TableRow {...otherProps}>
        <TableCell padding="checkbox">
          <IconButton onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {children}
      </TableRow>
      {isExpanded && (
        <TableRow>
          <TableCell padding="checkbox" />
          {expandComponent}
        </TableRow>
      )}
    </>
  );
};

export default function SimpleTable() {
  const [opens, setOpens] = React.useState(false);
  const handleOpen = () => setOpens(true);
  const handleClose = () => setOpens(false);
  const navigate = useNavigate();
  // console.log(USERLISTA);
  const [USERLIST, setgroupwisemember] = useState([]);
  const [MEMBERLIST, setmemberlist] = useState([]);
  const [memberview, setmemberview] = useState('');
  const [memberviewdetails, setmemberviewdetails] = useState('');
  const [userdelete, setuserdelete] = useState('');
  const [isLoader, setIsLoader] = useState(true);
  const [block, setblock] = useState([]);
  const [gp, setgp] = useState([]);
  const [blockValue, setblockValue] = useState('');
  const [gpValue, setgpvalue] = useState('');
  // const [codevalue, setcodeValue] = useState([]);
  useEffect(() => {
    fetchuser();
  }, []);
  const fetchuser = () => {
    axios
      .post(
        'http://drdc.rtcsindia.co.in/api/group_wise_group_member_details',
        { blockCode: blockValue, gpCode: gpValue },
        {
          headers: {
            Authorization: localStorage.getItem('id_token'),
            'content-type': 'application/json',
          },
        }
      )
      .then((response) => {
        setgroupwisemember(response.data.groupwisemember);
        setIsLoader(false);
        // console.log(response.data.userlist);
      })
      .catch((err) => {
        setIsLoader(false);
      });
  };
  const fetchblock = () => {
    axios
      .post(
        'http://drdc.rtcsindia.co.in/api/get_block',
        {},
        {
          headers: {
            Authorization: localStorage.getItem('id_token'),
            'content-type': 'application/json',
          },
        }
      )
      .then((response) => {
        setblock(response.data.options);
        // console.log(response.data.options);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    fetchblock();
  }, []);
  const changeblock = (e) => {
    // console.log(e.target.value);
    setblockValue(e.target.value);
    axios
      .post(
        'http://drdc.rtcsindia.co.in/api/get_gp',
        { block_code: e.target.value },
        {
          headers: {
            Authorization: localStorage.getItem('id_token'),
            'content-type': 'application/json',
          },
        }
      )
      .then((response) => {
        setgp(response.data.options);

        // console.log(response.data.options);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const changegp = (e) => {
    // console.log(e.target.value);
    setgpvalue(e.target.value);
  };
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1200,
    height: 'auto',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  const TABLE_HEAD = [
    { id: 'Group Code', label: 'Group Code', alignRight: false },
    { id: 'Name', label: 'Name', alignRight: false },
    { id: 'Bank name', label: 'Bank name', alignRight: false },
    { id: 'Branch name', label: 'Branch name', alignRight: false },
    { id: 'Block', label: 'Block', alignRight: false },
    { id: 'Gp', label: 'Gp', alignRight: false },
    { id: 'Action', label: 'Action', alignRight: false },
  ];
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('asc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('name');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    axios
      .post(
        'http://drdc.rtcsindia.co.in/api/member_view',
        { code: event.currentTarget.value },
        {
          headers: {
            Authorization: localStorage.getItem('id_token'),
            'content-type': 'application/json',
          },
        }
      )
      .then((response) => {
        setmemberview(response.data.groupdata);
        // setOpens(true);
        console.log(memberview);

        // navigate('/dashboard/user', { state: response.data.options });
        // console.log(response.data.userlist);
        // console.log(USERLIST);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleCloseMenu = () => {
    setOpen(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
    console.log(event);
    console.log(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const filteredUsers = applySortFilter(USERLIST, getComparator(order, orderBy), filterName);
  // console.log('filter', filteredUsers);

  const isNotFound = !filteredUsers.length && !!filterName;
  return (
    <>
      {isLoader ? (
        <Loader />
      ) : (
        <>
          <Container className="userlist-table">
            {/* <Grid container spacing={4} className="user-form" style={{ padding: '2%' }}>
              <Grid item xs={2}>
                <select
                  className="select-box"
                  label="demo-simple-select-label"
                  id="demo-simple-select"
                  onChange={changeblock}
                >
                  <option value="">Select Block</option>
                  {block.map((key) =>
                    key.code === blockValue ? (
                      <option selected name="block_code" key="" value={key.code}>
                        {key.block_name}
                      </option>
                    ) : (
                      <option name="block_code" key="" value={key.code}>
                        {key.block_name}
                      </option>
                    )
                  )}
                </select>
              </Grid>

              <Grid item xs={2}>
                <select
                  label="demo-simple-select-label"
                  className="select-box"
                  id="demo-simple-select"
                  onChange={changegp}
                >
                  <option value="">Select Gp</option>
                  {gp.map((key) =>
                    key.code === gpValue ? (
                      <option selected name="gp_code" key="" value={key.code}>
                        {key.gp_name}
                      </option>
                    ) : (
                      <option name="gp_code" key="" value={key.code}>
                        {key.gp_name}
                      </option>
                    )
                  )}
                </select>
              </Grid>
              <Grid item xs={2}>
                <Button className="button-search" onClick={fetchuser}>
                  Search
                </Button>
              </Grid>
            </Grid> */}

            <Card>
              <UserListToolbar
                numSelected={selected.length}
                filterName={filterName}
                onFilterName={handleFilterByName}
              />
              <Scrollbar>
                <Modal
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={style}>
                    <h1 style={{ textAlign: 'center' }}>Group Details</h1>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            SHG Code:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.shg_code}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Name:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.name}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Block Name:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.block_name}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            GP Name:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.gp_name}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Village Name:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.village_name}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Bank Name:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.bank_name}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Branch Name:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.branch_name}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            IFSC Code:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.ifsc_code}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Account No:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.account_no}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Nature Of Lively Activities:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.nature_of_livelyhood_activities}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Last Trainning Year:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.year_of_last_trainning}
                        </Grid>
                      </Grid>
                    </Typography>

                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Already Applied Load:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.already_applied_loan}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Loan Apply Or Not:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.loan_apply_or_not}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Amount:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.amount}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Repayment Done:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.repayment_done}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Application Submission Date:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.date_of_submission_of_application}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Application Sansantion Date:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.application_sansantion_date}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Sansantion Or Not:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.santion_or_not}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Sansantion Date:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.santion_date}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Sansantion Amount:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.santion_amount}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Last Trainning Date:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.last_trainning_date}
                        </Grid>
                      </Grid>
                    </Typography>
                    <Typography className="member-view-data" id="modal-modal-title" variant="h6" component="h2">
                      <Grid container spacing={4}>
                        <Grid item xs={6}>
                          <Typography variant="h6" gutterBottom>
                            Type:
                          </Typography>
                        </Grid>

                        <Grid item xs={6}>
                          {memberview.type}
                        </Grid>
                      </Grid>
                    </Typography>
                    <DialogActions>
                      <Button onClick={handleClose}>Close</Button>
                    </DialogActions>
                  </Box>
                </Modal>
                <TableContainer sx={{ minWidth: 800 }}>
                  <Table aria-label="simple table">
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={TABLE_HEAD}
                      rowCount={USERLIST.length}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                    />
                    {/* </TableHead> */}

                    <TableBody>
                      {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                        const { membername } = row;
                        const selectedUser = selected.indexOf(membername) !== -1;
                        return (
                          <ExpandableTableRow
                            scope="row"
                            key={row.code}
                            expandComponent={
                              <>
                                {/* <Table aria-label="simple table" style={{ width: '100%' }}> */}
                                <TableHead>
                                  <TableRow className="tablerow">
                                    <TableCell width="30%" align="right">
                                      Member Name
                                    </TableCell>
                                    <TableCell width="70%" align="right">
                                      Member Age
                                    </TableCell>
                                    <TableCell align="right">Caste</TableCell>
                                    <TableCell align="right">Phone No</TableCell>
                                    <TableCell align="right">Insurance</TableCell>
                                  </TableRow>
                                </TableHead>
                                {row.memberdetails.map((member) => (
                                  <>
                                    <TableBody className="tablecell">
                                      <TableCell component="th" scope="row">
                                        {member.membername}
                                      </TableCell>
                                      <TableCell>{member.memberage}</TableCell>
                                      <TableCell>{member.caste}</TableCell>
                                      <TableCell>{member.phno}</TableCell>
                                      <TableCell>{member.insurance}</TableCell>
                                    </TableBody>
                                  </>
                                ))}
                                {/* </Table> */}
                              </>
                            }
                          >
                            <TableCell component="th" scope="row">
                              {row.groupcode}
                            </TableCell>
                            <TableCell>{row.groupname}</TableCell>
                            <TableCell>{row.bankname}</TableCell>
                            <TableCell>{row.branchname}</TableCell>
                            <TableCell>{row.blockname}</TableCell>
                            <TableCell>{row.gpname}</TableCell>
                            <TableCell align="right">
                              <IconButton size="large" color="inherit" onClick={handleOpenMenu} value={row.code}>
                                <Iconify icon={'eva:more-vertical-fill'} />
                              </IconButton>
                            </TableCell>
                          </ExpandableTableRow>
                        );
                      })}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>

                    {isNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <Paper
                              sx={{
                                textAlign: 'center',
                              }}
                            >
                              <Typography variant="h6" paragraph>
                                Not found
                              </Typography>

                              <Typography variant="body2">
                                No results found for &nbsp;
                                <strong>&quot;{filterName}&quot;</strong>.
                                <br />
                                Try checking for typos or using complete words.
                              </Typography>
                            </Paper>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100, { value: -1, label: 'all' }]}
                component="div"
                count={USERLIST.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Card>
          </Container>
          <Popover
            open={Boolean(open)}
            anchorEl={open}
            onClose={handleCloseMenu}
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            PaperProps={{
              sx: {
                p: 1,
                width: 140,
                '& .MuiMenuItem-root': {
                  px: 1,
                  typography: 'body2',
                  borderRadius: 0.75,
                },
              },
            }}
          >
            <MenuItem>
              {/* <Iconify icon={'mdi:user-group'} sx={{ mr: 1 }}> */}
              Member Details
              {/* </Iconify> */}
            </MenuItem>
          </Popover>
        </>
      )}
    </>
  );
}
